<div class="nya-larm-wrapper container">
  <h2>{{ getKriteriaName() ? getKriteriaName() : "Nytt larmkriterium" }}</h2>

  <div class="d-flex flex-column mb-3">
    <label for="larmkriterier_namn">Namn</label>
    <input
      type="text"
      name="name"
      id="name"
      class="mb-2 form-control"
      [(ngModel)]="name"
      placeholder="Ange ett unikt namn för ditt kriterie"
      [disabled]="kriteriaToEdit !== undefined && !isCopy"
    />
    @if (errorMessage) {
      <ul class="px-4">
        <li class="text-danger">{{ errorMessage }}</li>
      </ul>
    }
    <label for="species">Smittämne</label>

    <select
      name="species"
      id="species"
      class="mb-2 form-select"
      [(ngModel)]="species"
      [disabled]="kriteriaToEdit !== undefined && !isCopy"
    >
      <option [defaultSelected]="defaultSmittamne" [ngValue]="defaultSmittamne" disabled>
        {{ defaultSmittamne.standardNamn }}
      </option>
      <option *ngFor="let option of smittamne" [ngValue]="option">
        {{ option.standardNamn }}
      </option>
    </select>

    <label for="type">Typ av larm</label>
    <select name="type" id="type" class="mb-2 form-select" [(ngModel)]="type" (ngModelChange)="onTypeChange($event)" >
      <option [defaultSelected]="true" [ngValue]="defaultType" disabled>
        {{ defaultType }}
      </option>
      <option *ngFor="let option of larmTyper" [ngValue]="option">
        {{ option }}
      </option>
    </select>
<!--    <div *ngIf="type === LarmTyp.LOKALT">-->
<!--      <label for="lab">Välj Lab</label>-->

<!--      <select id="lab" class="form-select" [(ngModel)]="selectedLab"  >-->
<!--        <option [ngValue]="undefined" disabled>-->
<!--          {{ defaultValj }}-->
<!--        </option>-->
<!--        <option *ngFor="let lab of SMEs" [ngValue]="lab">-->
<!--          {{ lab.name }}-->
<!--        </option>-->
<!--       &lt;!&ndash; <p-multiSelect formControlName="labCodes" [options]="SMEs" placeholder="Välj labb" optionLabel="label" /> &ndash;&gt;-->
<!--      </select>-->
<!--    </div>-->
    <label for="active">Aktivt</label>
    <select name="active" id="active" class="mb-2 form-select" [(ngModel)]="status">
      <option [value]="'AKTIV'">Ja</option>
      <option [value]="'INAKTIV'">Nej</option>
    </select>
  </div>

  <p-accordion>
    <p-accordion-panel value="analys">
      <p-accordion-header>Analys</p-accordion-header>
      <p-accordion-content>
        <p-pickList
          [source]="analyser"
          [target]="selectedAnalyser"
          sourceHeader="Valbara analyser"
          targetHeader="Valda analyser"
          [dragdrop]="true"
          [responsive]="true"
          [sourceStyle]="{ height: '30rem' }"
          [targetStyle]="{ height: '30rem' }"
          breakpoint="1400px"
          filterBy="standardNamn"
        >
        <ng-template let-analys pTemplate="item">
          <div class="flex flex-wrap p-2 align-items-center gap-3">
            <div class="flex align-items-center gap-2">
              <i class="fas fa-flask text-sm"></i>
              <span> {{ analys.standardNamn }}</span>
            </div>
          </div>
        </ng-template>
        </p-pickList>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
  <p-accordion>
    <p-accordion-panel value="provmaterial">
      <p-accordion-header>Provmaterial</p-accordion-header>
      <p-accordion-content>
        <p-pickList
          [source]="provmaterial"
          [target]="selectedProvmaterial"
          sourceHeader="Valbara provmaterial"
          targetHeader="Valda provmaterial"
          [dragdrop]="true"
          [responsive]="true"
          [sourceStyle]="{ height: '30rem' }"
          [targetStyle]="{ height: '30rem' }"
          breakpoint="1400px"
          filterBy="standardNamn"
        >
          <ng-template let-analys pTemplate="item">
            <div class="flex flex-wrap p-2 align-items-center gap-3">
              <div class="flex align-items-center gap-2">
                <i class="fas fa-flask text-sm"></i>
                <span> {{ analys.standardNamn }}</span>
              </div>
            </div>
          </ng-template>
        </p-pickList>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <!-- <label for="bevakningsperiod">Bevakningsperiod (dagar)</label>
    <input type="number" class="form-control" />
    <label for="larmfrekvens">Antal larm inom bevakningsperiod</label>
    <input type="number" class="form-control" /> -->
  <p-accordion>
    <p-accordion-panel value="antibiotika">
      <p-accordion-header>Antibiotika</p-accordion-header>
      <p-accordion-content>
        <div class="d-flex align-items-center mb-2" *ngIf="antibiotikaKriteria.length > 0">
          <span class="m-2">Visa subkriteria</span>
          <p-inputSwitch [(ngModel)]="showSubkriteria" [ngModelOptions]="{ standalone: true }" />
        </div>
        <div class="antibiotika-wrapper" *ngFor="let kriteria of antibiotikaKriteria; let index = index">
          <div *ngIf="antibiotikaKriteria.length > 1 && index !== 0" class="radio-group">
            <label for="och" style="margin-right: 0.5rem">Och</label>
            <input
              type="radio"
              name="subkriteria_{{ index }}"
              id="och"
              style="margin-right: 1rem"
              value="och"
              [(ngModel)]="andOrRelations[index]"
              [ngModelOptions]="{ standalone: true }"
            />
            <label for="eller" style="margin-right: 0.5rem">Eller</label>
            <input
              type="radio"
              name="subkriteria_{{ index }}"
              id="eller"
              style="margin-right: 1rem"
              value="eller"
              [(ngModel)]="andOrRelations[index]"
              [ngModelOptions]="{ standalone: true }"
            />
          </div>
          <div class="antibiotika-container rounded">
            <select
              name="Antibiotika"
              id="Antibiotika"
              class="form-select antibiotika-select"
              [(ngModel)]="kriteria.selectedAntibiotika"
              [ngModelOptions]="{ standalone: true }"
            >
              <option [defaultSelected]="defaultAntibiotika" [ngValue]="defaultAntibiotika" disabled>
                {{ defaultAntibiotika.standardNamn }}
              </option>
              <option *ngFor="let option of antibiotika" [ngValue]="option">
                {{ option.standardNamn }}
              </option>
            </select>
            <div class="sub-kriteria mt-2" *ngIf="showSubkriteria">
              <div class="">
                <label for="sir">SIR</label>
                <br />
                <select class="form-select" [(ngModel)]="kriteria.sir" [ngModelOptions]="{ standalone: true }">
                  <option [defaultSelected]="defaultValj" [ngValue]="defaultValj">
                    {{ defaultValj }}
                  </option>
                  <option *ngFor="let option of sirValues" [ngValue]="option">
                    {{ option }}
                  </option>
                </select>
              </div>
              <div>
                <label for="zon">Zon mindre än (mm)</label>
                <br />
                <input
                  type="number"
                  name="zon"
                  id="zon"
                  class="form-control"
                  [(ngModel)]="kriteria.zon"
                  [min]="6"
                  [max]="50"
                  (ngModelChange)="updateZone($event, kriteria)"
                  [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                  placeholder="Zon"
                />
              </div>
              <div>
                <label for="tolk">MIC (tolk)</label>
                <br />
                <select class="form-select" [(ngModel)]="kriteria.tolk" [ngModelOptions]="{ standalone: true }">
                  <option [defaultSelected]="defaultValj" [ngValue]="defaultValj">
                    {{ defaultValj }}
                  </option>
                  <option *ngFor="let option of sirValues" [ngValue]="option">
                    {{ option }}
                  </option>
                </select>
              </div>
              <div>
                <label for="mic">MIC större än</label>
                <br />
                <select class="form-select" [(ngModel)]="kriteria.mic" [ngModelOptions]="{ standalone: true }">
                  <option [defaultSelected]="defaultValj" [ngValue]="defaultValj">
                    {{ defaultValj }}
                  </option>
                  <option *ngFor="let option of micValues" [ngValue]="option">
                    {{ option }}
                  </option>
                </select>
              </div>
            </div>
            <div class="w-100 text-end">
              <button type="button" class="btn btn-primary mt-3" (click)="deleteAntibiotikaKriteria(index)">
                <i class="fas fa-save"></i> Ta bort
              </button>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-primary mt-3" (click)="addAntibiotika()">
          <i class="fas fa-save"></i> Lägg till antibiotika
        </button>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>

  <app-button buttonStyle="secondary" icon="times" text="Avbryt" (click)="cancel()"></app-button>
  <app-button
    buttonStyle="primary"
    class="float-end"
    text="Spara larmkriterium"
    icon="save"
    [disabled]="!canSave()"
    [callback]="save"
  >
  </app-button>
  @if (undefinedAntibiotics) {
    <p class="text-danger">{{ undefinedAntibiotics }}</p>
  }
</div>
